import React from "react";
import { Link } from "react-router-dom";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import { connect } from "react-redux";
import Dropable from "../Dropable";
import { CATEGORY } from "../TasksList/constants";

const MenuFocus = props => (
  <div>
    <Dropable name={CATEGORY.FOCUS}>
      <ListItem button>
        <ListItemIcon classes={{ root: 'new-MuiListItemIcon-root' }}>
          <Link to="/focus">
            <StarBorderIcon />
            {!props.isOpenDrawer &&
              <div>{`Focus (${props.tasksFoucsCouter})`}</div>}
          </Link>
        </ListItemIcon >
        <Link to="/focus">
          <ListItemText primary={`Focus (${props.tasksFoucsCouter})`} />
        </Link>
      </ListItem>
    </Dropable>
  </div>
);

const mapStateToProps = state => {
  function isFocus(idTask) {
    const task = state.tasks[idTask];
    return (task.focus && !task.project && !task.done);
  }

  const tasks =
    state.tasks &&
    Object.keys(state.tasks)
      .filter(isFocus);

  return {
    tasksFoucsCouter: tasks ? tasks.length : 0
  };
};

export default connect(mapStateToProps, null)(MenuFocus);

